module.exports = __webpack_public_path__ + "img/14_windAndRain_wgf.fb7bf8b5.png";